import { createLogic } from 'redux-logic';
import { stopSubmit, reset, setSubmitFailed, setSubmitSucceeded } from 'redux-form';
import { GET_CODE_PENDING } from '../constants';
import { getCodeSuccess, setBannerState, clearBannerState, setDigitalMediaStatus, fetchProductImageURLs } from '../actions/AppActions';

const form = 'redeemCode';

const tableName = (category) => {
  switch (category.toUpperCase()) {
    case 'EBOOK':
      return 'eBooks';
    case 'FILE_DOWNLOAD':
      return 'downloads';
    case 'MEMBERSHIPS':
      return 'memberships';
    case 'RENTAL':
    case 'VIDEO':
      return 'videos';
    case 'SIMULCAST':
      return 'simulcasts';
    default:
      return 'other content';
  }
};

const errorCategory = (message) => message.match(/category ".*?"/i)?.[0]?.match(/"([^"]+)"/)?.[1];

const alreadyOwnedMessage = (errorMessage) => {
  const category = errorCategory(errorMessage);
  return `We noticed you have already redeemed this code. Please check ${category ? `${tableName(category)} in ` : ''}your digital media.`
};

export const redemptionCodeErrorMessage = (errorCode) => {
  switch (errorCode) {
    case 'CTG_USED':
      return 'This code has reached its redemption limit for this group and can no longer be used.';
    case 'LIMIT_EXCEEDED':
      return 'This code has reached its redemption limit for this group and can no longer be used.';
    case 'ALREADY_REDEEMED':
      return 'This code has already been redeemed. Please check your digital media.';
    case 'EXPIRED':
      return 'The code you entered has expired. Please try a different code.';
    case 'NOT_YET_ACTIVE':
      return 'Redemption code is expired or not yet active. Please try again later.';
    default:
      return 'The code you entered cannot be redeemed right now. Please try again later.';
  }
};

export const getCodePendingLogic = createLogic({
  type: GET_CODE_PENDING,
  latest: true,
  validate({ action }, allow, reject) {
    if (!action.payload.code) {
      reject(stopSubmit(form, {}));
    } else {
      allow(action);
    }
  },
  process({ httpClient, action, getState }, dispatch, done) {
    const state = getState();
    const intl = state.intl.messages;
    dispatch(clearBannerState());
    httpClient(dispatch).post('/code-redemptions', { code: action.payload.code })
      .then(res => {
        const { code, name, seats } = res.data || {};
        const itemNumbers = seats?.map(seat => seat.itemNumber);
        if (itemNumbers) dispatch(fetchProductImageURLs({ itemNumbers }));
        dispatch(setBannerState({ data: { message: intl.Errors.RedeemCode.Get_Code_Success } }));
        dispatch(reset(form));
        dispatch(setSubmitSucceeded(form));
        dispatch(getCodeSuccess({ code, name, items: seats }));
        dispatch(setDigitalMediaStatus(false));
      })
      .catch(error => {
        const userId = state?.app?.getIn(['currentUser'])?.toJS()?.id;
        const redemptionError = error?.response?.data?.error;
        const alreadyOwnedByUser = !!(redemptionError?.code === 'CTG_USED' && userId && redemptionError?.message?.toLowerCase().includes(userId.toLowerCase()));
        const bannerState = alreadyOwnedByUser
          ? { message: alreadyOwnedMessage(redemptionError?.message) }
          : { type: 'error', message: redemptionCodeErrorMessage(redemptionError?.code) }
        dispatch(setBannerState({ data: bannerState }));
        dispatch(reset(form));
        dispatch(setSubmitFailed(form));
      })
      .finally(() => done());
  }
});

export default [
  getCodePendingLogic
];
